export class MessageTypesRequest {
  private Action = 'getmessagetypes';

  constructor() {}
}
